<div class="animated fadeIn">
  <app-configurations-block [serverMode]="true" [collapsible]="false" />
</div>
